import React from 'react';
import cx from 'classnames';

import styles from './Title.module.scss';

type TitleProps = {
  children?: React.ReactNode | string | null;
  className?: string;
  element?: React.ElementType;
  large?: boolean;
}

export const Title = ({
  children = null,
  className,
  element: Element = 'h2',
  large = false,
  ...restProps
}: TitleProps) => (
  <Element className={cx(styles.content, { [styles.large]: large }, className)} {...restProps}>
    {children}
  </Element>
);
